import VeiviserTrinnBlock from './VeiviserTrinnBlock';

globalThis.VeiviserComponents = {
  VeiviserTrinnBlock,
};
